export default __webpack_public_path__ + "static/media/linkedin_white.de09e758.svg";